import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
import {
  AppBar,
  Box,
  Button,
  Divider,
  IconButton,
  Toolbar,
  Badge,
  Typography,
} from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import MenuIcon from "../icons/Menu";
import Logo from "./Logo";
import ChatSection from "./room/sections/ChatSection";
import {
  StickyNote2,
  Textsms,
} from "@material-ui/icons";
import { useSelector } from "../store";
import store from "../store/index";
import { setNewNotification } from "../slices/roomSlice";
import Notes from "./Notes";
import AlertDialog from "./AlertDialog";
import { createSR } from "../api/serviceRequest";
import MicButton from "./room/sections/video/MicButton";
import CameraButton from "./room/sections/video/CameraButton";
import SwitchToScreenShareButton from "./room/sections/video/SwitchToScreenShareButton";
import InviteButton from "./room/sections/video/InviteButton";
import Timer from "./room/sections/video/Timer";
import TutorialButton from "./room/sections/video/TutorialButton";
import SettingsButton from "./room/sections/video/SettingsButton";
import EndCallButton from "./EndCallButton";

const MainNavbar = (props) => {
  const { onSidebarMobileOpen } = props;
  const isDesktop = useMediaQuery("(min-width:960px)");
  const [open, setOpen] = useState(false);
  const [showNotesDialogue, setShowNotesDialogue] = useState(false);
  const [showAlertDialog, setShowAlertDialog] = useState(false);
  const [alertSuccessMessage, setAlertSuccessMessage] = useState(null);
  const [alertType, setAlertType] = useState(null);

  const {
    newNotification,
    participants,
    teamMemberId,
    callEnded,
    identity,
    fromUrl,
  } = useSelector((state) => {
    return state.room;
  });

  // window.addEventListener("beforeunload", (ev) => {
  //     // alert('Hi');
  //     ev.preventDefault();
  //     return ev.returnValue = 'Are you sure you want to close?';
  // });

  useEffect(() => {
    store.dispatch(setNewNotification(0));
  }, [open]);

  useEffect(() => {
    if (teamMemberId && alertType === "endCall") {
      setAlertSuccessMessage("Call Ended");
      setShowAlertDialog(true);
    }
  }, [callEnded]);

  const openChatWindow = () => {
    setOpen(true);
  };

  const closeChatWindow = () => {
    setOpen(false);
  };

  const handleEndCall = () => {
    setAlertType("endCall");
    setAlertSuccessMessage("Call Ended");
    setShowAlertDialog(true);
  };

  const handleCreateSR = async () => {
    // const notes = localStorage.getItem("notes");
    const roomData = store.getState().room;
    const res = await createSR(
      roomData.roomId,
      roomData.teamMemberId,
      roomData.notes,
      identity
    );

    // console.log("createSR - res", res);

    if (res.success === true) {
      setAlertSuccessMessage(res.message + " : " + res.sr_no);
    } else {
      // console.log("Create SR err", res.message);
      setAlertSuccessMessage("Something went wrong! Try again");
    }
    setAlertType("createSR");
    setShowAlertDialog(true);
  };

  const closeAlertDialog = () => {
    setShowAlertDialog(false);
    // console.log("alertType", alertType);
    
    if (alertType === "endCall") {
      // Try to close window first
      window.close();
      
      // Fallback: redirect to call-ended page if window doesn't close
      setTimeout(() => {
        if (!window.closed) {
          window.location.href = "/call-ended";
        }
      }, 1000);
    } else if (fromUrl || alertType == "createSR") {
      window.close();
    }
  };

  const handleOpenChatWindowTouchEnd = (e) => {
    e.preventDefault();
    openChatWindow();
  };

  return (
    <>
      {showNotesDialogue && (
        <Notes
          showNotesDialogue={showNotesDialogue}
          setShowNotesDialogue={setShowNotesDialogue}
        />
      )}

      {showAlertDialog && (
        <AlertDialog
          open={showAlertDialog}
          handleClose={closeAlertDialog}
          successMsg={alertSuccessMessage}
        />
      )}
      <AppBar
        elevation={0}
        sx={{
          backgroundColor: "primary.main",
          color: "text.secondary",
        }}
      >
        <Toolbar sx={{ minHeight: 64 }}>
          {isDesktop ? (
            <RouterLink to="/">
              <Logo
                sx={{
                  display: {
                    md: "inline",
                  },
                  height: {
                    xs: 70,
                    md: 55,
                  },
                  position: { xs: "fixed", md: "static" },
                  bottom: { xs: "64px", md: "auto" },
                  left: { xs: 16, md: "auto" },
                  zIndex: { xs: 1300, md: "auto" },
                }}
              />
            </RouterLink>
          ) : (
            <Logo
              sx={{
                display: {
                  md: "inline",
                },
                height: 55,
                position: { xs: "fixed", md: "static" },
                bottom: { xs: "64px", md: "auto" },
                left: { xs: 16, md: "auto" },
                zIndex: { xs: 1300, md: "auto" },
              }}
              id="iconnect-logo"
            />
          )}
          <Box sx={{ flexGrow: 1 }} />
          <Box
            sx={{
              alignItems: "center",
              display: "flex",

            }}
            className="iconnect-nav-buttons"
          >
            {participants.length ? <Timer /> : ""}
            <MicButton />
            <CameraButton />
            <SwitchToScreenShareButton />
            <TutorialButton />
            {teamMemberId ? <InviteButton /> : ""}
            <Button
              onClick={openChatWindow}
              onTouchEnd={handleOpenChatWindowTouchEnd}
              sx={{
                color: "white",
                boxShadow: "none",
              }}
              variant="contained"
            >
              <Box sx={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                <Badge badgeContent={newNotification} color="success">
                  <Textsms />
                </Badge>
                <Typography sx={{ mt: 0, fontSize: "12px" }}>
                  Chat
                </Typography>
              </Box>
            </Button>

            {teamMemberId ? <Button
              onClick={() => setShowNotesDialogue(true)}
              sx={{
                color: "white",
                boxShadow: "none",
              }}
              variant="contained"
            >
              <Box sx={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                <StickyNote2 />
                <Typography sx={{ mt: 0, fontSize: "12px" }}>
                  Notes
                </Typography>
              </Box>
            </Button> : ""}

            <Button
              variant="outlined"
              onClick={() => handleCreateSR()}
              sx={{
                backgroundColor: "background.paper",
                color: "text.primary",
                ml: 1,
                display: teamMemberId ? "block" : "none",
              }}
            >
              Create SR
            </Button>
            <EndCallButton onEndCall={handleEndCall} />
            <SettingsButton />
          </Box>
        </Toolbar>
        <Divider />
        <ChatSection open={open} closeChatWindow={closeChatWindow} />
      </AppBar>
    </>
  );
};

MainNavbar.propTypes = {
  onSidebarMobileOpen: PropTypes.func,
};

export default MainNavbar;
